/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportFieldSettingsUpdateRequest } from '../models/ReportFieldSettingsUpdateRequest';
import type { ReportFieldSettingsUpdateResponse } from '../models/ReportFieldSettingsUpdateResponse';
import type { ReportTemplateFieldSettings } from '../models/ReportTemplateFieldSettings';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BusinessReportService {
    /**
     * Get Report Field Settings
     * 사업별 보고서 필드 설정 조회.
     *
     * 코드에 정의된 보고서 템플릿/필드 목록에 현재 사업의 저장된 설정(prompt 등)을
     * 머지하여 반환한다. 프론트는 이 응답만으로 설정 폼을 렌더할 수 있다.
     * `template_key` 를 주면 해당 템플릿만 반환한다.
     * @returns ReportTemplateFieldSettings OK
     * @throws ApiError
     */
    public static appsBusinessViewsGetReportFieldSettings({
        businessId,
        templateKey,
    }: {
        businessId: string,
        templateKey?: string,
    }): CancelablePromise<Array<ReportTemplateFieldSettings>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/business/{business_id}/report-field-settings',
            path: {
                'business_id': businessId,
            },
            query: {
                'template_key': templateKey,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Report Field Settings
     * 사업별 보고서 필드 설정(현재는 prompt)을 필드 단위로 병합 저장.
     *
     * - 보낸 (template, field) 만 갱신되고 나머지 설정/보고서 설정은 보존된다.
     * - 코드에 없는 template/field 는 저장되지 않고 `dropped` 로 회신된다.
     * - 허용되지 않은 프롬프트 변수/형식 오류는 400.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns ReportFieldSettingsUpdateResponse OK
     * @throws ApiError
     */
    public static appsBusinessViewsUpdateReportFieldSettings({
        businessId,
        requestBody,
    }: {
        businessId: string,
        requestBody: ReportFieldSettingsUpdateRequest,
    }): CancelablePromise<ReportFieldSettingsUpdateResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/business/{business_id}/report-field-settings',
            path: {
                'business_id': businessId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
